import clsx from "clsx";
import React from "react";
import { useTheme } from "~app/providers/ThemeProvider";
import { ThemeMode } from "~app/utils/types";

const ThemeToggle = () => {
  const { toggleTheme, theme } = useTheme();

  const handleThemeChange = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const newTheme = e.currentTarget.dataset.theme as ThemeMode;
    toggleTheme(newTheme || theme);
  };

  return (
    <>
      <button
        onClick={handleThemeChange}
        data-theme="window98"
        className={clsx("button", {
          "button--active": theme === "window98",
          "button--inactive": theme !== "window98",
        })}
      >
        Windows 98
      </button>
      <button
        onClick={handleThemeChange}
        data-theme="dark"
        className={clsx("button", {
          "button--active": theme === "dark",
          "button--inactive": theme !== "dark",
        })}
      >
        Dark
      </button>
      <button
        onClick={handleThemeChange}
        data-theme="light"
        className={clsx("button", {
          "button--active": theme === "light",
          "button--inactive": theme !== "light",
        })}
      >
        Light
      </button>
      <button
        onClick={handleThemeChange}
        data-theme="glossy"
        className={clsx("button", {
          "button--active": theme === "glossy",
          "button--inactive": theme !== "glossy",
        })}
      >
        Glossy
      </button>
    </>
  );
};

export default ThemeToggle;
